import React from 'react';

export default function DocumentIndex() {
    return <div/>
}